function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classnames from 'classnames';
import { Text } from "../../Typography";
import styles from './BlockLabel.scss';

function BlockLabel(_ref) {
  var children = _ref.children,
      type = _ref.type,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    size: "small",
    className: classnames(styles.blockLabel, className, _defineProperty({}, styles["type-".concat(String(type))], type))
  }, children);
}

BlockLabel.defaultProps = {
  type: undefined,
  className: undefined
};
export default BlockLabel;